export default __webpack_public_path__ + "static/media/showMenuIcon.ed1a22ff.svg";